import React from "react";
import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";
import memoryPic from "../../assets/memoryPic.png";
import { Image } from "react-bootstrap";




const JsRealisations = () => {
    return (
        <div className="">
            <p className="text-white">Jeux memory realisé en JavaScript</p>
            <div className="card shadow-sm">
                <h6>Memory-sim</h6>
                <Image src={memoryPic} style={{ height: '320px', width: "90%", margin: "auto" }} alt="capture" fluid="true" />
                <p className="pMemory">
                    Memory game en javascript <Link to={{ pathname: "https://memory-sim-omar.netlify.app/" }} target="_blank">&nbsp;&nbsp;&nbsp;
                        <span className="pMemory">
                            Visiter
                        </span>
                        <FaIcons.FaExternalLinkAlt style={{ color: "#daef0a" }} /></Link>
                </p>
            </div>
        </div>
    )
}

export default JsRealisations;